import React from 'react';
import { GoogleMapsLoader, GeoSearch, CustomMarker } from 'react-instantsearch-dom-maps';
import { Popover, OverlayTrigger, Card, Button } from 'react-bootstrap';
import { Link } from "@StarberryUtils";
import imageConfig from "../../../static/images/config.json";
import { ShowProcessedImage } from '../Common/ggfx-client/module/components/show-image';
import MarkerIcon from '../../images/marker.png';
import closeIcon from '../../images/close.png';
import _ from "lodash"
const GATSBY_GOOGLE_MAP_KEY = process.env.GATSBY_GOOGLE_MAP_KEY
console.log("GATSBY_GOOGLE_MAP_KEY : ",GATSBY_GOOGLE_MAP_KEY);
const Marker = ({ data, key }) => {
    const [show, setShow] = React.useState(false);
    const target = React.useRef(null);
    const priceTag = (val) => {
        if (!_.isEmpty(val)) {
            return _.startCase(val.split(/(?=[A-Z])/).join(' '));
        } else {
            return ""
        }
    }

    return (
        <OverlayTrigger
            placement="auto"
            target={target.current}
            show={show}
            overlay={
                <Popover id={`popover-${key}`} className="popover-m">
                    <Popover.Content className="p-0">
                        <Card style={{ minWidth: "100%" }} className="p-0 position-relative border-0">
                            {data.images && data.images.length > 0 &&
                                <ShowProcessedImage
                                    images={data.images[0]}
                                    transforms={imageConfig.property.searchResults1.sizes}
                                    attr={{
                                        className: "mb-0"
                                    }}
                                />
                            }
                            <Card.Body className="pt-0">
                                <Card.Title className="mb-1 title">{data.title}</Card.Title>
                                <Card.Title className="mb-1 description">{data.display_address}</Card.Title>
                                <Card.Title className="mb-1 description">{priceTag(data.price_qualifier)} £{data.price.toLocaleString()}</Card.Title>

                                <Link to={`/property-${data.searchType === "sales" ? "for-sale" : "to-rent"}/${data.slug}-${data.objectID}`} className="btn btn-primary">View Property</Link>
                            </Card.Body>
                            <div className="close-btn" onClick={() => setShow(false)}>
                                x
                            </div>
                        </Card>
                    </Popover.Content>
                </Popover>
            }
        >
            <Button ref={target} onClick={() => setShow(!show)} style={{ pointerEvents: "all" }} className="map-btn">
                <img src={MarkerIcon} width="30" height="30" />
            </Button>
        </OverlayTrigger>
    )
}

function MapMobile(props) {
    return (
        <div className="property-map-geo" style={{ height: "60vh", width: "100vw" }}>
            <GoogleMapsLoader apiKey={process.env.GATSBY_GOOGLE_MAP_KEY} >
                {google => (
                    <GeoSearch
                        google={google}
                        enableRefineOnMapMove={false}
                        initialZoom={1}
                    >
                        {({ hits }) => (
                            <div className={hits.length} id="saravanan">
                                {hits.map((hit, i) => (
                                    <CustomMarker
                                        key={i}
                                        hit={hit}
                                    >
                                        <Marker data={hit} />
                                    </CustomMarker>
                                )
                                )}
                            </div>
                        )}
                    </GeoSearch>
                )}
            </GoogleMapsLoader>
        </div>
    );
}

export default React.memo(MapMobile);
